import React from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";

const PwAlerts = () => {

  const showAlert = () => {
    window.alert("This is a Simple Alert");
  };

  const showConfirm = () => {
    window.confirm("Do you want to continue?");
  };

  const showPrompt = () => {
    window.prompt("Enter your name:");
  };

  const showLineBreakAlert = () => {
    window.alert("This is line 1\nThis is line 2\nThis is line 3");
  };

  const sections = [
    {
      heading: "CLICK TO DISPLAY ALERT",
      ui: (
        <div className={styles.alertCard}>
          <button className={styles.alertBtn} onClick={showAlert}>
            HIT ME
          </button>
        </div>
      ),
      code: `page.on('dialog', async dialog => {
  console.log(dialog.message());
  await dialog.accept();
});

await page.click('text=HIT ME');`
    },
    {
      heading: "CLICK TO DISPLAY CONFIRM BOX",
      ui: (
        <div className={styles.alertCard}>
          <button className={styles.alertBtn} onClick={showConfirm}>
            HIT ME
          </button>
        </div>
      ),
      code: `page.on('dialog', async dialog => {
  await dialog.accept(); // or dialog.dismiss();
});

await page.click('text=HIT ME');`
    },
    {
      heading: "CLICK TO DISPLAY PROMPT BOX",
      ui: (
        <div className={styles.alertCard}>
          <button className={styles.alertBtn} onClick={showPrompt}>
            HIT ME
          </button>
        </div>
      ),
      code: `page.on('dialog', async dialog => {
  await dialog.accept('Logesh');
});

await page.click('text=HIT ME');`
    },
    {
      heading: "CLICK TO LEARN LINE-BREAKS IN ALERT",
      ui: (
        <div className={styles.alertCard}>
          <button className={styles.alertBtn} onClick={showLineBreakAlert}>
            HIT ME
          </button>
        </div>
      ),
      code: `page.on('dialog', async dialog => {
  console.log(dialog.message());
  await dialog.accept();
});

await page.click('text=HIT ME');`
    }
  ];

  return <PlaywrightTemplate title="ALERTS" sections={sections} />;
};

export default PwAlerts;